import { action, computed, makeObservable, observable, toJS } from "mobx";
import fetchData from "../utils/fetchData";

export default class WasteStore {
  // inital value
  formsRaw = [];
  formDataRaw = [];
  formId = null;
  groupsFilled = [];
  wasteDataByYear = [];
  isLoading = false;

  // constructor
  constructor() {
    makeObservable(this, {
      // observable values
      formsRaw: observable,
      formDataRaw: observable,
      formId: observable,
      groupsFilled: observable,
      wasteDataByYear: observable,
      isLoading: observable,
      // computed values
      forms: computed,
      formsSubmitted: computed,
      formData: computed,
      // actions
      create: action.bound,
      fetchForms: action.bound,
      fetchFormData: action.bound,
      fetchWasteByYear: action.bound,
    });
   
  }

  // computed
  get forms() {
    return toJS(this.formsRaw);
  }

  get formsSubmitted() {
    return toJS(this.formsRaw);
  }

  get formData() {
    return toJS(this.formDataRaw);
  }
}

// actions

WasteStore.prototype.fetchForms = function ({ showAlert }) {
  fetchData("add-water/getAllWaterForms", {
    method: "POST",
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status) {
        this.formsRaw = data.data;
        return;
      }
      showAlert?.(data.message);
    })
    .catch((err) => {
      showAlert?.(err.message);
      console.error(err);
    });
};

WasteStore.prototype.create = function ({
  data,
  companyId,
  companyUnit,
  frequency,
  kpiId,
  subCatId,
  catId,
  showAlert,
  navigate,
  totalGroups,
  update,
  groupData,
  formId,
  setEditForm,
}) {
  const payload = data?.value?.map((e) => ({
    ...e,
    prevValue: Number(e.prevValue) || 0,
    target: Number(e.target) || 0,
    unit: Number(e.unit),
    companyId: Number(companyId),
    companyUnit: Number(companyUnit),
    fieldId: Number(e.fieldId),
    fieldGroup: data.group,
    value: e.value,
    groupName: e.group,
    comment: e.comment,
    attachment: e.attachment,
  }));
  const groupPayload = [
    {
      ...frequency,
      kpiId,
      subCatId,
      catId,
      targetValue: data.target,
      prevValue: data.prevValue,
      unitId: companyUnit,
      companyUnit,
      groupName: data.group,
    },
  ];
  const token = JSON.parse(
    localStorage.getItem("access-token") ||
      localStorage.getItem("admin-access-token")
  )?.token;
  const formData = new FormData();
  formData.append("data", JSON.stringify(payload));
  formData.append("groupPayload", JSON.stringify(groupPayload));
  payload.forEach((pay, index) => {
    // if (pay.attachment) {
    //   formData.append(`file[]`, pay.attachment);
    //   formData.append(`index[]`, index);
    // }
    if (pay?.attachment?.length) {
      for (let i = 0; i < pay.attachment.length; i++) {
        // Check if the attachment is an actual File object
        if (pay.attachment[i] instanceof File) {
          formData.append(`file[]`, pay.attachment[i]); // Append file
          formData.append(`index[]`, pay.fieldId); // Associate with fieldId
        } else {
          console.log(pay.attachment[i], "Skipping, as it's a file path");
        }
      }
    }
  });
  fetch(
    process.env.REACT_APP_BASE_URL +
      `waste-management/${update ? "update" : "create"}${
        formId ? `?formId=${formId}` : ""
      }`,
    {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((res) => res.json())
    .then((response) => {
      if (response.status) {
        showAlert(response.message, true);
        if (update) {
          setEditForm("");
        }
        if (response.data.groupsFilled.length === totalGroups) {
          navigate("/company/waste");
          return;
        }
        navigate("/company/waste/add-waste", {
          state: {
            freq: frequency,
            formid: response.data.formId,
            groupsFilled: response.data.groupsFilled,
            formData: groupData,
          },
        });
        return;
      }
      showAlert(response.message);
    })
    .catch((err) => {
      showAlert(err.message);
      console.error(err);
    });
};

WasteStore.prototype.fetchFormData = function ({ formId, showAlert }) {
  fetchData(`waste-management/getFormData?formId=${formId}`, {
    method: "POST",
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status) {
        this.formDataRaw = data.data;
        return;
      }
      showAlert?.(data.message);
    })
    .catch((err) => {
      showAlert?.(err.message);
      console.error(err);
    });
};

WasteStore.prototype.fetchWasteByYear = function ({ year, companyUnit, showAlert }) {
  return new Promise((resolve, reject) => {
    const token = JSON.parse(
      localStorage.getItem("access-token") ||
        localStorage.getItem("admin-access-token")
    )?.token;
    this.isLoading = true;
    this.wasteDataByYear = [];
    fetch(process.env.REACT_APP_BASE_URL + `waste-management/getDataByYear`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ year, companyUnit }),
    })
      .then((res) => res.json())
      .then((response) => {
        this.isLoading = false;
        if (response.success) {
          this.wasteDataByYear = response.data;
          resolve(response.data);
          return;
        }
        showAlert?.(response.message);
        reject(new Error(response.message));
      })
      .catch((err) => {
        this.isLoading = false;
        showAlert?.(err.message);
        console.error("Error fetching waste data by year:", err);
        reject(err);
      });
  });
};

//financial year

// WasteStore.prototype.fetchWasteByYear = function ({ startYear, endYear, showAlert }) {
//   console.log("entered fetchWasteByFinancialYear");

//   return new Promise((resolve, reject) => {
//     const token = JSON.parse(
//       localStorage.getItem("access-token") ||
//       localStorage.getItem("admin-access-token")
//     )?.token;

//     this.isLoading = true;
//     this.wasteDataByYear = [];

//     fetch(`${process.env.REACT_APP_BASE_URL}waste-management/getDataByFinancialYear`, {
//       method: "POST",
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         frequencyYear: [String(startYear), String(endYear)],
//       }),
//     })
//       .then(res => res.json())
//       .then(response => {
//         this.isLoading = false;
//         if (response.success) {
//           this.wasteDataByYear = response.data;
//           resolve(response.data);
//           return;
//         }
//         showAlert?.(response.message);
//         reject(new Error(response.message));
//       })
//       .catch(err => {
//         this.isLoading = false;
//         showAlert?.(err.message);
//         console.error("Error fetching waste data by FY:", err);
//         reject(err);
//       });
//   });
// };
